module.exports = __webpack_public_path__ + "img/kaokaotalk_code.c4dbbfe1.png";